export default __webpack_public_path__ + "static/media/gallery_04@2x.0ce40dc5.jpg";